export default __webpack_public_path__ + "static/list-block-1-bg-phone-ba2c1795631b3f104c263b0e77490c9e.png";